import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditPage from "../../components/pages_cms/FormAddEditPage";
import { useGetPageById } from "../../hooks/pages/useGetPageById";

const EditPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { page, isLoading } = useGetPageById(id);

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            {isLoading ? (
                <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}>
                    <CircularProgress />
                </Box>
            ) : (
                <FormAddEditPage
                    isEdit={true}
                    currentData={page?.data}
                    onSubmitSuccess={() => navigate("/pages")}
                />
            )}
        </WrapperSection>
    );
};

export default EditPage;
